export default __webpack_public_path__ + "static/media/icon_user-edit.a31b51ea.svg";